import axios from 'axios'

// 用户端
export const getBalance = () =>
  axios.get('/api/billing/balance')

export const getBillingSummary = (params) =>
  axios.get('/api/billing/summary', { params })

export const getTransactions = (params) =>
  axios.get('/api/billing/transactions', { params })

export const getResourceUsage = (params) =>
  axios.get('/api/billing/resource-usage', { params })

export const getStandardAnalysisRuns = (params) =>
  axios.get('/api/billing/standard-analysis-runs', { params })

export const getTcmClinicalAnalyses = (params) =>
  axios.get('/api/billing/tcm-clinical-analyses', { params })

export const getSessionCosts = (params) =>
  axios.get('/api/billing/session-costs', { params })

export const getSessionDirectories = (params) =>
  axios.get('/api/billing/session-directories', { params })

export const getSessionChildren = (params) =>
  axios.get('/api/billing/session-costs/children', { params })

export const getBillingTrend = (params) =>
  axios.get('/api/billing/trend', { params })

// 流式导出账单流水（大数据量时使用）
export const exportTransactions = (params) =>
  axios.get('/api/billing/transactions/export', { params, responseType: 'blob' })

// 公开的系统配置读取（如存储免费额度），不需要管理员权限。
// 后端按白名单返回（仅 billing.storage_free_gb 等公开键）。
// key: 配置键名，如 'billing.storage_free_gb'
export const getPublicBillingConfig = (key) =>
  axios.get('/api/billing/public-config', { params: { key } })

// 管理端
export const getAdminDailyTokenUsage = (params) =>
  axios.get('/api/admin/billing/dailyTokenUsage', { params })

export const getAdminModelTokenUsage = (params) =>
  axios.get('/api/admin/billing/modelTokenUsage', { params })

export const getAdminBillingDashboard = () =>
  axios.get('/api/admin/billing/dashboard')

export const getAdminUserBalances = (params) =>
  axios.get('/api/admin/billing/users', { params })

// 导出用户余额列表
export const exportAdminUserBalances = () =>
  axios.get('/api/admin/billing/users/export', { responseType: 'blob' })

export const getAdminUserBalance = (userId) =>
  axios.get(`/api/admin/billing/user/${userId}/balance`)

export const adminRecharge = (data) =>
  axios.post('/api/admin/billing/recharge', data)

export const adminAdjust = (data) =>
  axios.post('/api/admin/billing/adjust', data)

export const getAdminUserTransactions = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/transactions`, { params })

// 导出指定用户的流水
export const exportAdminUserTransactions = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/transactions/export`, { params, responseType: 'blob' })

export const getAdminUserResourceUsage = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/resource-usage`, { params })

export const getAdminUserTokenUsageDaily = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/token-usage-daily`, { params })

export const getAdminUserSessionCosts = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/session-costs`, { params })

export const getAdminUserSessionChildren = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/session-costs/children`, { params })

export const getAdminTrend = (params) =>
  axios.get('/api/admin/billing/trend', { params })

// 资源消耗碱基币比例分析（换算比例 + 消费占比）
export const getAdminResourceRatio = (params) =>
  axios.get('/api/admin/billing/resource-ratio', { params })

export const getAdminUserTrend = (userId, params) =>
  axios.get(`/api/admin/billing/user/${userId}/trend`, { params })

export const getPrices = () =>
  axios.get('/api/admin/billing/prices')

export const updatePrices = (data) =>
  axios.put('/api/admin/billing/prices', data)

export const getAdminModels = () =>
  axios.get('/api/admin/billing/models')

export const getAdminModelsPricing = () =>
  axios.get('/api/admin/billing/models-pricing')

// 管理员查询所有碱基币流水（带用户名称/企业名称）
export const getAdminAllTransactions = (params) =>
  axios.get('/api/admin/billing/transactions/all', { params })

// 管理端「当前活跃」：时间窗口内有扣费流水的身份聚合
export const getAdminActiveIdentities = (params) =>
  axios.get('/api/admin/billing/transactions/active', { params })

export const getUserBalance = () =>
  axios.get('/api/billing/balance')

// ─── 企业管理（管理端）───

export const getAdminEnterprises = () =>
  axios.get('/api/admin/billing/enterprises')

// 旧版一锤子创建（已弃用，保留兼容）
export const createEnterprise = (data) =>
  axios.post('/api/admin/billing/enterprises', data)

export const getEnterpriseDeletePreview = (id) =>
  axios.get(`/api/admin/billing/enterprises/${id}/delete-preview`)

export const deleteEnterprise = (id, data = {}) =>
  axios.delete(`/api/admin/billing/enterprises/${id}`, { data })

// ─── 企业开通流程（V20 4 阶段：DRAFT → AWAIT_CLUSTER → CLUSTER_READY → BOUND）───
// 详见 文档/新集群部署/与管理员对齐方案.md

// 阶段 1：管理台填表落库（DRAFT）
export const createEnterpriseDraft = (data) =>
  axios.post('/api/admin/enterprises/draft', data)

// 阶段 2：DRAFT → AWAIT_CLUSTER，落 placeholder 池
export const submitEnterpriseProvisioning = (id) =>
  axios.post(`/api/admin/enterprises/${id}/submit`)

// 渲染给管理员的命令清单（4 tab + install.sh + mailto）
export const getEnterpriseAdminInstructions = (id) =>
  axios.get(`/api/admin/enterprises/${id}/admin-instructions`)

// 阶段 3：同步 SSH 探针检测（≤ 30s 阻塞），全过自动推到 CLUSTER_READY
export const runEnterpriseClusterProbe = (id) =>
  axios.post(`/api/admin/enterprises/${id}/probe`, null, { timeout: 60000 })

// 探针不可用/测试环境手工验收：人工确认企业池已就绪
export const confirmEnterpriseClusterReady = (id) =>
  axios.post(`/api/admin/enterprises/${id}/confirm-ready`)

// CLUSTER_READY 状态的「指定 Owner」候选池
export const getEnterpriseOwnerCandidates = (id) =>
  axios.get(`/api/admin/enterprises/${id}/owner-candidates`)

// 阶段 4：CLUSTER_READY → BOUND，指定 owner
export const setEnterpriseOwner = (id, data) =>
  axios.post(`/api/admin/enterprises/${id}/owner`, data)

// V20.1：admin 视角企业 Linux 用户池总览（含已绑定 identity / user 信息）
export const getEnterprisePoolOverview = (id) =>
  axios.get(`/api/admin/enterprises/${id}/pool-overview`)

// V20.1：扫描集群上已存在的 Linux 用户（按 prefix / linux_group 过滤）
export const scanEnterpriseClusterUsers = (id, max = 200) =>
  axios.get(`/api/admin/enterprises/${id}/cluster-users-scan`, { params: { max }, timeout: 60000 })

// 批量补充企业 Linux 用户池（落 status=0 的可用池行）
// body: { users: [{ linuxUsername, port?, homeDir?, password? }, ...] }
export const registerEnterprisePoolUsers = (id, users) =>
  axios.post(`/api/admin/enterprises/${id}/pool/register-batch`, { users })

// 回填企业 OS 元字段（V20.2 起还接受 linuxUsernamePrefix / expectedPoolSize，兼容旧企业补全）
export const patchEnterpriseLinuxBinding = (id, data) =>
  axios.patch(`/api/admin/enterprises/${id}/linux-binding`, data)

// ─── 充值审核（管理端）───

export const getRechargeOrders = (params) =>
  axios.get('/api/admin/billing/recharge/orders', { params })

export const getPendingAudits = (params) =>
  axios.get('/api/admin/billing/recharge/audits', { params })

export const auditRecharge = (id, data) =>
  axios.post(`/api/admin/billing/recharge/audits/${id}`, data)

// 会员订单套餐明细（product_type=2/3 的订单）
export const getRechargeOrderItems = (orderId) =>
  axios.get(`/api/admin/billing/recharge/orders/${orderId}/items`)

// 订阅持有列表（含历史；status：0=待生效 1=生效中 2=已结束）
export const getSubscriptionHolders = (params) =>
  axios.get('/api/admin/billing/subscription-holders', { params })

// ─── 发票管理（管理端）───

export const getPendingInvoices = (params) =>
  axios.get('/api/admin/billing/invoices/pending', { params })

export const getAllInvoices = (params) =>
  axios.get('/api/admin/billing/invoices', { params })

export const issueInvoice = (id, data) =>
  axios.post(`/api/admin/billing/invoices/${id}/issue`, data)

export const rejectInvoice = (id, data) =>
  axios.post(`/api/admin/billing/invoices/${id}/reject`, data)

// ─── 充值档位管理（管理端）───

export const getAdminPackages = () =>
  axios.get('/api/admin/billing/packages')

export const createPackage = (data) =>
  axios.post('/api/admin/billing/packages', data)

export const updatePackage = (id, data) =>
  axios.put(`/api/admin/billing/packages/${id}`, data)

export const togglePackageStatus = (id) =>
  axios.post(`/api/admin/billing/packages/${id}/toggle`)

// 上传发票PDF（接收 File 对象或 FormData）
export const uploadInvoicePdf = (fileOrFormData) => {
  let formData
  if (fileOrFormData instanceof FormData) {
    formData = fileOrFormData
  } else {
    formData = new FormData()
    formData.append('file', fileOrFormData)
  }
  return axios.post('/api/admin/invoices/upload-pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 获取发票详情（管理端）
export const getAdminInvoiceDetail = (id) =>
  axios.get(`/api/admin/billing/invoices/${id}`)
